import { useTranslation } from 'react-i18next';
import React, { lazy, Suspense, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import useViewportVisibility from './useViewportVisibility';

// Keep the chart engine out of the console's initial bundle.
const Renderer = lazy(() => import('./EChartRenderer'));
const MapRenderer = lazy(() => import('./WorldMapRenderer'));

export default React.memo(function EChart(props) {
  const { t: translate } = useTranslation();
  const target = useRef(null);
  const { visible, seen } = useViewportVisibility(target);
  const ChartRenderer = props.option?.series?.some((series) => series.type === 'map') ? MapRenderer : Renderer;
  return <Box ref={target} sx={{ minHeight: props.height || 300, minWidth: 0 }}><Suspense fallback={
    <Box role="status" sx={{ height: props.height || 300, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
      <CircularProgress size={16} />
      <Typography variant="caption" color="text.secondary">{translate('assistant.eChartLoadingChart')}</Typography>
    </Box>
  }>
    {seen && <ChartRenderer {...props} visible={visible} />}
  </Suspense></Box>;
});
